import React from 'react'
import OtpInput from '@ntuctech/devex-tangram/OtpInput'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'
import { SvgLoading } from '@ntuctech/devex-tangram/Icon'
import { OTPInputDiv } from './LoginScreen/elements'
import { Subtitle } from './styled'

const OTP_LENGTH = 6

const VerifyOtp = ({
  isVerifying,
  maskedUserDetails,
  otpInputHelpText,
  otpNumber,
  selectedOtpMethod,
  send,
  setOtpNumber,
}) => {
  return (
    <div>
      <Subtitle>
        Please enter the One-Time password (OTP) received via your registered
        &nbsp;
        {selectedOtpMethod.label} (
        <b>{maskedUserDetails[selectedOtpMethod.key]}</b>).
      </Subtitle>
      <OTPInputDiv>
        <OtpInput
          data-testid="otp-input"
          value={otpNumber}
          disabled={isVerifying}
          helpText={otpInputHelpText}
          isNum
          label={`Enter ${OTP_LENGTH}-digit OTP`}
          length={OTP_LENGTH}
          error={!!otpInputHelpText}
          onChange={setOtpNumber}
          resendTimer={90}
          onResend={() => send({ type: 'REQUEST_OTP' })}
        />
      </OTPInputDiv>
      <ButtonContained
        data-testid="otp-submit-button"
        disabled={otpNumber.length !== OTP_LENGTH || isVerifying}
        fullWidth
        onClick={() =>
          send({
            type: 'SUBMIT_OTP',
            memberId: maskedUserDetails.id,
          })
        }
      >
        {isVerifying ? <SvgLoading color="#1454b8" /> : 'Submit'}
      </ButtonContained>
      <ButtonContained
        data-testid="otp-cancel-button"
        disabled={isVerifying}
        fullWidth
        onClick={() => send({ type: 'ON_CANCEL_PRESSED' })}
        color="grey"
      >
        Cancel
      </ButtonContained>
    </div>
  )
}

export default VerifyOtp
